module.exports = __webpack_public_path__ + "static/img/logo.c17fe26d.png";